/* eslint-disable multiline-ternary */
/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable new-cap */

import {
    EmbedEvent,
    EmbedEvents,
} from '../types/events'

import audioManager, {AudioEvents} from 'utils/audio'

import {
    chatsIcon,
    closeIcon, conversationIcon, dropdownIcon, minimizeIcon, newMessageIcon, resizeIcon,
    shrinkIcon,
    spinnerIcon,
    switchCheckIcon,
    switchXIcon,
    videoIcon,
} from './icons'

import {
    floatingContainer,
    floatingContainerBall,
    floatingContainerContent,
    floatingContainerHeader,
    floatingContainerInner,
    floatingContainerPromoBubble,
    floatingContainerWrapper,
} from '../styles'

import {DropdownOptions} from 'embed/types/dropdown'
import {EmbedState} from 'embed/types/state'
import {EmbedStorage} from 'components/Embed/types'
import {NinchatEnvironmentConfig} from 'embed/types'
import {ResponsiveBreakpoints} from 'embed/types/responsive'
import {RouteName} from 'embed/types/routes'
import {ThemeManager} from 'embed/helpers/themeManager'

import {downloadFile} from 'utils/download'
import {focusFirstElement} from 'embed/helpers'
import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import showdown from 'showdown'

// Showdown passes all raw HTML through by default and has no sanitize/allowlist
// option. This extension strips any author-supplied HTML tag from the markdown
// source except <small>/</small>, while leaving the tags Showdown itself
// generates (<p>, <a>, ...) untouched.
const ALLOWED_HTML_TAGS = new Set(['small'])
const HTML_TAG_PATTERN = /<\/?(?<tag>[a-z][a-z0-9-]*)\b[^>]*?>/giu

const allowlistHtmlExtension: showdown.ShowdownExtension = {
    filter: (text: string): string => text.replace(
        HTML_TAG_PATTERN,
        (match, tag: string) => (ALLOWED_HTML_TAGS.has(tag.toLowerCase()) ? match : ''),
    ),
    type: 'lang',
}

const markdownConverter = new showdown.Converter({extensions: [allowlistHtmlExtension]})
markdownConverter.setOption('simpleLineBreaks', true)
// possible options to configure https://github.com/showdownjs/showdown#valid-options

interface FloatingContainerTemplateProps {
    config: NinchatEnvironmentConfig
    content: string,
    tm: ThemeManager
    breakpoints: ResponsiveBreakpoints
}

const state: {
    [key: string]: EmbedState
} = {}

// const focusable = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])'

type HeaderActionsConfig = NonNullable<NonNullable<NonNullable<NinchatEnvironmentConfig['floatingOptions']>['headerOptions']>['actions']>;
type HeaderActions = HeaderActionsConfig[keyof HeaderActionsConfig];

type DropdownOptionsConfig = NonNullable<NonNullable<NonNullable<NinchatEnvironmentConfig['floatingOptions']>['headerOptions']>['dropdownOptions']>;

type ActionType = 'close' | 'minimize' | 'expand' | 'chatList' | 'dropdown';

const renderIcon = (
    actions: HeaderActions,
    actionType: ActionType,
    defaultIconFn: (title: string, id?: string) => string,
    id?: string,
// eslint-disable-next-line max-params
) => {
    const actionConfig = actions?.[actionType]
    const title = actionConfig?.buttonTitle || ''
    let image = ''

    if (typeof actionConfig?.icon === 'object') {
        if (actionConfig.icon.src) {
            image = `<img src='${actionConfig.icon.src}' alt='${actionConfig.icon.alt || ''}' width='${actionConfig.icon.width || ''}' height='${actionConfig.icon.height || ''}' />`
        } else if (actionConfig.icon.svg) {
            image = `<div class='ninchat-embed-header-button-image-svg-wrapper' style='width: ${actionConfig.icon.width || ''}px; height: ${actionConfig.icon.height || ''}px;'>${actionConfig.icon.svg}</div>`
        } else {
            image = `<div class='ninchat-embed-header-button-image-svg-wrapper' style='width: ${actionConfig.icon.width || ''}px; height: ${actionConfig.icon.height || ''}px;'>${id ? defaultIconFn(title, id) : defaultIconFn(title)}</div>`
        }
    } else if (actionConfig?.icon === true) {
        image = id ? defaultIconFn(title, id) : defaultIconFn(title)
    }

    if (!image) {
        return ''
    }

    return `<div class='ninchat-embed-header-button-image'>${image}</div>`
}

const renderCloseIcon = (actions: HeaderActions) => renderIcon(actions, 'close', closeIcon)
const renderMinimizeIcon = (actions: HeaderActions) => renderIcon(actions, 'minimize', minimizeIcon)
const renderResizeIcon = (actions: HeaderActions) => renderIcon(actions, 'expand', resizeIcon)
const renderShrinkIcon = (actions: HeaderActions, id: string) => renderIcon(actions, 'expand', shrinkIcon, id)
const renderChatsIcon = (actions: HeaderActions) => renderIcon(actions, 'chatList', chatsIcon)
const renderDropdownIcon = (actions: HeaderActions) => renderIcon(actions, 'dropdown', dropdownIcon)


export const floatingContainerComponentTemplate = ({
    content, tm, config, breakpoints,
}: FloatingContainerTemplateProps) => {
    const options = config?.floatingOptions
    const embedStateClass = options?.initialState === 'minimized' ? 'ninchat-embed-minimized minimize-transition-end' : options?.initialState === 'full' ? 'ninchat-embed-full' : ''

    const isMinimized = options?.initialState === 'minimized'
    const isExpanded = options?.initialState === 'full'
    const currentState = isMinimized ? 'minimized' : isExpanded ? 'full' : 'open'

    const sessionKey = config?.sessionKey || ''
    state[sessionKey] ??= {}
    state[sessionKey].state = currentState

    const embedHeaderTitle = options?.headerOptions?.title ? options?.headerOptions?.title[currentState] : ''
    const actions = options?.headerOptions?.actions ? options.headerOptions.actions[options?.initialState || 'open'] : undefined
    const showChatList = actions?.chatList?.icon || actions?.chatList?.text
    const showDropdown = actions?.dropdown?.icon || actions?.dropdown?.text
    const showMinimize = actions?.minimize?.icon || actions?.minimize?.text
    const showExpand = (actions?.expand?.icon || actions?.expand?.text) && options?.initialState !== 'full'
    const showShrink = (actions?.expand?.icon || actions?.expand?.text) && options?.initialState === 'full'
    const showClose = actions?.close?.icon || actions?.close?.text

    const embedId = `ninchat-embed-${Math.random().toString()}`

    const hasAllowedDropdownOptions = (options?.headerOptions?.dropdownOptions || []).length > 0

    return `
        <div class='ninchat-embed-wrapper  ${floatingContainerWrapper(config, tm, breakpoints)}'>
            <div id=${embedId} class='ninchat-embed hide ${floatingContainer(config, tm, breakpoints)} ${embedStateClass}' role='dialog' aria-modal='true'>
                 ${options?.ball ? '' : `<div class='ninchat-embed-promobubble-wrapper hide ${floatingContainerPromoBubble(config, tm, breakpoints)}'>
                    <div class='ninchat-embed-promobubble-inner'>
                        ${options?.promoBubble?.items?.map((pb, ind) => `<button class='ninchat-embed-promobubble'>
                                ${markdownConverter.makeHtml(pb?.content || ' ')} 
                                ${ind === 0 ? `<button class='ninchat-embed-promobubble-close-button'>${closeIcon()}</button>` : ''} 
                            </button>`).join('') || ''}
                    </div>
                </div>`}
                <div class="ninchat-embed-inner ${floatingContainerInner(config, tm, breakpoints)}">
                    <div class="ninchat-embed-header ${floatingContainerHeader(config, tm, breakpoints)}">
                        <div class='ninchat-embed-header-content'>
                            <div class='ninchat-embed-buttons left'>
                                <button class='ninchat-embed-chatlist-button ${showChatList ? '' : 'hide'}'>
                                    ${renderChatsIcon(actions)} <span class='text'>${actions?.chatList?.text || ''}</span>
                                </button>
                                <button class='ninchat-embed-dropdown-button ${showDropdown ? '' : 'hide'}'>
                                    ${renderDropdownIcon(actions)} <span class='text'>${actions?.dropdown?.text || ''}</span>
                                </button>
                                  ${hasAllowedDropdownOptions ? `<div class="ninchat-embed-dropdown">
                                        <ul class="ninchat-embed-dropdown-content">
                                        </ul>
                                    </div>` : ''} 
                            </div>
                            <div class='ninchat-embed-buttons center ${!showChatList && !showDropdown ? 'no-left-actions' : ''}'>
                                    <button class='ninchat-embed-header-title-button ${isMinimized ? '' : 'hide'} ${!showChatList && !showDropdown ? 'no-left-actions' : ''}'>
                                        <div class='ninchat-embed-header-image-wrapper'>
                                        </div>
                                        <div class='ninchat-embed-header-title-wrapper'>
                                            <div class='ninchat-embed-header-title'>${embedHeaderTitle || ''}</div>
                                            <div class='ninchat-embed-header-subtitle'></div>
                                        </div>
                                    </button>
                            </div>
                            <div class='ninchat-embed-buttons right'>
                                <button class='ninchat-embed-minimize-button ${showMinimize ? '' : 'hide'}'>
                                    <span class='text'>${actions?.minimize?.text || ''}</span> ${renderMinimizeIcon(actions)}
                                </button>    
                                <button class='ninchat-embed-expand-button ${showExpand ? '' : 'hide'}'>
                                    <span class='text'>${actions?.expand?.text || ''}</span> ${renderResizeIcon(actions)}
                                </button>
                                <button class='ninchat-embed-shrink-button ${showShrink ? '' : 'hide'}'>
                                   <span class='text'>${actions?.expand?.text || ''}</span> ${renderShrinkIcon(actions, `ninchat-embed-shrink${Math.random().toString()}`)} 
                                </button>
                                <button class='ninchat-embed-close-button ${showClose ? '' : 'hide'}'>
                                    <span class='text'>${actions?.close?.text || ''}</span>${renderCloseIcon(actions)} 
                                </button>
                            </div>  
                        </div>  
                    </div>
                    <div class="ninchat-embed-content ${floatingContainerContent(config, tm, breakpoints)}">${content}</div>
                </div>
            </div>
            ${options?.ball ?
        `<div class='ninchat-embed-ball hide hide-transition-end ${floatingContainerBall(config, tm, breakpoints)}'>
                <div class='ninchat-embed-promobubble-wrapper hide ${floatingContainerPromoBubble(config, tm, breakpoints)}'>
                    <div class='ninchat-embed-promobubble-inner'>
                        ${options?.promoBubble?.items?.map((pb, ind) => `
                            <button class='ninchat-embed-promobubble'>
                                ${markdownConverter.makeHtml(pb?.content || '')}
                                ${ind === 0 ? `<button class='ninchat-embed-promobubble-close-button'>${closeIcon()}</button>` : ''} 
                            </button>`).join('') || ''}
                    </div>
                </div>
                <div class='ninchat-embed-ball-button-wrapper'>
                    <button class='ninchat-embed-ball-button' aria-haspopup='dialog' aria-controls=${embedId} aria-expanded='${!isMinimized}'>
                        <div class='ninchat-embed-ball-button-content'>
                            <div class='ninchat-embed-ball-image-wrapper'></div>
                            ${options?.ballOptions?.text ? `<div class='ninchat-embed-ball-text'>${options.ballOptions?.text}</div>` : ''}
                        </div>
                    </button>
                    ${options?.ballOptions?.close ? `<button class='ninchat-embed-ball-close-button'>${closeIcon()}</button>` : ''}
                </div>
            </div>`
        : ''}
        </dialog>
    `
}

const renderHeader = (config: NinchatEnvironmentConfig, emit: (event: Partial<EmbedEvents>) => void) => {
    const options = config?.floatingOptions
    const sessionKey = config?.sessionKey || ''

    if (!state[sessionKey].container) {
        return
    }

    const embed = state[sessionKey]?.container?.querySelector('.ninchat-embed')
    const embedHeader = state[sessionKey]?.container?.querySelector('.ninchat-embed-header')
    const embedHeaderTitleButton = state[sessionKey]?.container?.querySelector('.ninchat-embed-header-title-button')
    const embedHeaderTitle = state[sessionKey]?.container?.querySelector('.ninchat-embed-header-title')
    const embedHeaderSubtitle = state[sessionKey]?.container?.querySelector('.ninchat-embed-header-subtitle')
    const embedBallImageWrapper = state[sessionKey]?.container?.querySelector('.ninchat-embed-ball-image-wrapper')

    const isMinimized = embed?.classList.contains('ninchat-embed-minimized')
    const isFull = embed?.classList.contains('ninchat-embed-full')
    const currentState = isMinimized ? 'minimized' : isFull ? 'full' : 'open'

    if (currentState !== state[sessionKey].state) {
        emit({
            event: EmbedEvent.State,
            state: currentState,
        })
        state[sessionKey].state = currentState
    }

    const {
        isVideoActive, heroFullVisible, heroFullAbsoluteVisible, isVideoChannel,
    } = state[sessionKey]

    const defaultTitle = (isMinimized ? options?.headerOptions?.title?.minimized : isFull ? options?.headerOptions?.title?.full : options?.headerOptions?.title?.open) || ''
    const defaultImage = options?.headerOptions?.image?.svg ? `<div class='ninchat-embed-header-image-svg-wrapper'>${options?.headerOptions?.image?.svg}</div>` :
        options?.headerOptions?.image?.src ? `<img class='ninchat-embed-header-image' alt='${options?.headerOptions?.image?.alt || ''}' src='${options?.headerOptions?.image?.src}' />` : ''

    const defaultBallImage = options?.ballOptions?.image?.svg ? `<div class='ninchat-embed-ball-image-svg-wrapper'>${options?.ballOptions?.image?.svg}</div>` :
        options?.ballOptions?.image?.src ? `<img class='ninchat-embed-ball-image' alt='${options.ballOptions?.image?.alt || ''}' src='${options.ballOptions?.image?.src}' />` : options?.ballOptions?.text ? '' : `<div class='ninchat-embed-ball-image-default'>${conversationIcon}</div>`


    const embedHeaderImageWrapper = state[sessionKey]?.container?.querySelector('.ninchat-embed-header-title-button .ninchat-embed-header-image-wrapper')

    if (!isMinimized) {
        state[sessionKey].channelStatus = undefined
    }

    if (heroFullVisible || heroFullAbsoluteVisible || isVideoChannel) {
        if (embedHeader) {
            embedHeader.classList.add('hero-visible')
        }
    } else if (embedHeader) {
        embedHeader.classList.remove('hero-visible')
    }

    if (isMinimized) {
        embedHeaderTitleButton?.classList.add('active-button')
        embedHeaderTitleButton?.removeAttribute('tabindex')
    } else {
        embedHeaderTitleButton?.classList.remove('active-button')
        embedHeaderTitleButton?.setAttribute('tabindex', '-1')
    }

    if (state[sessionKey].currentRoute?.name === RouteName.EmbedChannel) {
        if (!heroFullVisible) {
            embedHeaderTitleButton?.classList.add('active-button')
            embedHeaderTitleButton?.removeAttribute('tabindex')
        }

        const {members} = state[sessionKey]
        const membersToRender = members ? [...members] : []

        const isChannel = config?.channelId
        const iconsToDisplay = 3

        if (embedHeaderTitle) {
            let titleText = ''
            if (isChannel) {
                titleText = state[sessionKey].channelAttrs?.name || ''
            } else if (heroFullVisible || heroFullAbsoluteVisible) {
                titleText = defaultTitle
            } else {
                titleText = `${membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay)
                    // eslint-disable-next-line no-extra-parens
                    .map((member) => config?.agentName || (member?.details?.name + (membersToRender.length > 1 && (config?.agentJobTitle ?? member?.details?.info?.job_title) ? `(${config?.agentJobTitle ?? member?.details?.info?.job_title ?? ''})` : '')))
                    .join(', ')}${membersToRender.length > iconsToDisplay ? `<span> + ${membersToRender.length - iconsToDisplay + 1}</span>` : ''}`
            }

            embedHeaderTitle.innerHTML = isMinimized ? defaultTitle : titleText
        }

        if (embedHeaderSubtitle) {
            let subtitleText = ''
            if (isChannel || heroFullVisible || heroFullAbsoluteVisible) {
                subtitleText = ''
            } else {
                subtitleText = membersToRender.length > 1 ? '' : membersToRender?.map((member) => config?.agentJobTitle ?? member?.details?.info?.job_title).join(', ') || ''
            }
            embedHeaderSubtitle.innerHTML = isMinimized ? '' : subtitleText
        }

        if (embedHeaderImageWrapper) {
            if (isMinimized) {
                if (['unread', 'highlight'].includes(state[sessionKey]?.channelStatus || '')) {
                    embedHeaderImageWrapper.innerHTML = `<div class='ninchat-embed-state-icon-wrapper newMessage'>${newMessageIcon}</div>${defaultImage}`
                } else if (isVideoActive) {
                    embedHeaderImageWrapper.innerHTML = `<div class='ninchat-embed-state-icon-wrapper video'>${videoIcon}</div>${defaultImage}`
                } else {
                    embedHeaderImageWrapper.innerHTML = defaultImage
                }
            } else if (isChannel) {
                const channelName = state[sessionKey]?.channelAttrs?.name || ''
                embedHeaderImageWrapper.innerHTML = channelName[0] ? `<div class='ninchat-embed-member-icon'>${channelName[0] || ''}</div>` : ''
            } else if (heroFullVisible || heroFullAbsoluteVisible) {
                embedHeaderImageWrapper.innerHTML = defaultImage
            } else {
                embedHeaderImageWrapper.innerHTML = `${membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay)
                    .map((member) => {
                        if (config.agentAvatar?.svg) {
                            return `<div class='ninchat-embed-member-image'>${config.agentAvatar.svg}</div>`
                        } else if (config.agentAvatar?.src) {
                            return `<img class='ninchat-embed-member-image' alt='${config.agentAvatar.alt || config.agentName || ''}' src='${config.agentAvatar.src}' />`
                        } else if (config.agentName) {
                            return `<div class='ninchat-embed-member-icon'>${config.agentName[0] || ''}</div>`
                        }
                        return member.details.iconurl ? `<img class='ninchat-embed-member-image' alt='${member.details?.name || ''}' src='${member.details.iconurl}' />` : member.details?.name ? `<div class='ninchat-embed-member-icon'>${member.details?.name[0]}</div>` : ''
                    })
                    .join(' ')}${membersToRender.length > iconsToDisplay ? `<div class='ninchat-embed-member-icon'>+${membersToRender.length - iconsToDisplay + 1}</div>` : ''}`
            }
        }

        if (embedBallImageWrapper) {
            if (['unread', 'highlight'].includes(state[sessionKey]?.channelStatus || '')) {
                embedBallImageWrapper.innerHTML = `<div class='ninchat-embed-state-icon-wrapper newMessage'>${newMessageIcon}</div>`
            } else if (isVideoActive) {
                embedBallImageWrapper.innerHTML = `<div class='ninchat-embed-state-icon-wrapper video'>${videoIcon}</div>`
            } else {
                embedBallImageWrapper.innerHTML = defaultBallImage
            }
        }
    } else if (state[sessionKey].currentRoute?.name === RouteName.EmbedQueue) {
        if (embedHeaderTitle) {
            embedHeaderTitle.innerHTML = defaultTitle
        }

        if (embedHeaderSubtitle) {
            embedHeaderSubtitle.innerHTML = ''
        }

        if (embedHeaderImageWrapper) {
            embedHeaderImageWrapper.innerHTML = isMinimized ? `<div class='ninchat-embed-state-icon-wrapper spinner'>${spinnerIcon(Math.random().toString())} <span>${state[sessionKey].queuePosition || ''}</span></div>${defaultImage}` : defaultImage
        }

        if (embedBallImageWrapper) {
            embedBallImageWrapper.innerHTML = `<div class='ninchat-embed-state-icon-wrapper spinner'>${spinnerIcon(Math.random().toString())} <span>${state[sessionKey].queuePosition || ''}</span></div>`
        }
    } else {
        if (embedHeaderTitle) {
            embedHeaderTitle.innerHTML = defaultTitle
        }

        if (embedHeaderSubtitle) {
            embedHeaderSubtitle.innerHTML = ''
        }

        if (embedHeaderImageWrapper) {
            embedHeaderImageWrapper.innerHTML = defaultImage
        }

        if (embedBallImageWrapper) {
            embedBallImageWrapper.innerHTML = defaultBallImage
        }
    }
}

const sendUIToStorage = (sendMessage: ({event}: Partial<EmbedEvents>) => void, sessionKey: string) => {
    sendMessage({
        event: EmbedEvent.EmbedUI,
        ui: {
            mute: !!state[sessionKey]?.mute,
            openState: state[sessionKey]?.state || 'open',
            promoBubbleHidden: !!state[sessionKey]?.promoBubbleHidden,
        },
    })
}

const loadUIFromStorage = (
    sessionKey: string,
    ui: EmbedStorage['ui'],
    config: NinchatEnvironmentConfig,
) => {
    const {container} = state[sessionKey]

    if (!container) {
        return
    }

    if (ui.mute === true) {
        state[sessionKey].mute = ui.mute
        audioManager.mute()
    } else if (ui.mute === false) {
        state[sessionKey].mute = ui.mute
        audioManager.unmute()
    }

    // floating embed
    const embed = container.querySelector('.ninchat-embed')
    if (!embed) {
        return
    }

    // container state override
    if (ui.openState) {
        if (ui.openState === 'full') {
            embed.classList.remove('ninchat-embed-minimized')
            embed.classList.add('ninchat-embed-full')
            embed.classList.remove('minimize-transition-end')
        } else if (ui.openState === 'minimized') {
            embed.classList.remove('ninchat-embed-full')
            embed.classList.add('ninchat-embed-minimized')
        } else {
            embed.classList.remove('ninchat-embed-minimized')
            embed.classList.remove('ninchat-embed-full')
            embed.classList.remove('minimize-transition-end')
        }

        state[sessionKey].state = ui.openState
    }
    embed?.classList.remove('hide')


    const promoBubble = container.querySelector('.ninchat-embed-promobubble-wrapper')
    // promo bubble state override
    if (ui.promoBubbleHidden === true) {
        if (promoBubble) {
            promoBubble.classList.add('hide-pernament')
        }
    } else if (promoBubble) {
        if (config?.floatingOptions?.promoBubble?.showTimeout) {
            setTimeout(() => {
                promoBubble.classList.remove('hide')
                audioManager.playSound('promoBubble')
            }, config?.floatingOptions?.promoBubble?.showTimeout || 0)
        } else {
            promoBubble.classList.remove('hide')
            audioManager.playSound('promoBubble')
        }
    }

    const embedBall = container.querySelector('.ninchat-embed-ball')
    if (embedBall) {
        if (embed.classList.contains('ninchat-embed-minimized')) {
            embedBall.classList.remove('hide')
            embedBall.classList.remove('hide-transition-end')
        }
    }

    // enable transitions after initial state is set
    setTimeout(() => {
        embed?.classList.add('transitions-enabled')
        embedBall?.classList.add('transitions-enabled')
    }, 100)
}

export const render = (config: NinchatEnvironmentConfig, container: HTMLElement, emit: (event: Partial<EmbedEvents>) => void) => {
    const options = config?.floatingOptions

    if (!container) {
        return
    }

    const embed = container.querySelector('.ninchat-embed')
    const chatListButton = container.querySelector('.ninchat-embed-chatlist-button')
    const dropdownButton = container.querySelector('.ninchat-embed-dropdown-button')
    const minimizeButton = container.querySelector('.ninchat-embed-minimize-button')
    const expandButton = container.querySelector('.ninchat-embed-expand-button')
    const shrinkButton = container.querySelector('.ninchat-embed-shrink-button')
    const closeButton = container.querySelector('.ninchat-embed-close-button')

    if (!embed) {
        return
    }

    const isMinimized = embed.classList.contains('ninchat-embed-minimized')
    const isExpanded = embed.classList.contains('ninchat-embed-full')
    const currentState: 'minimized' | 'open' | 'full' = isMinimized ? 'minimized' : isExpanded ? 'full' : 'open'
    const actions = options?.headerOptions?.actions ? options.headerOptions.actions[currentState] : undefined
    const showChatList = actions?.chatList?.icon || actions?.chatList?.text
    const showDropdown = actions?.dropdown?.icon || actions?.dropdown?.text
    const showMinimize = actions?.minimize?.icon || actions?.minimize?.text
    const showExpand = (actions?.expand?.icon || actions?.expand?.text) && currentState !== 'full'
    const showShrink = (actions?.expand?.icon || actions?.expand?.text) && currentState === 'full'
    const showClose = actions?.close?.icon || actions?.close?.text

    const sessionKey = config?.sessionKey || ''

    const dropdownContent = document.querySelector('.ninchat-embed-dropdown-content')
    const soundOn = !state[sessionKey].mute

    const renderDropdownOptions = (dropdownOptions: DropdownOptionsConfig) => dropdownOptions.map((option) => {
        if (option.name === DropdownOptions.Mute) {
            return `
                    <li class="ninchat-embed-dropdown-item">
                        <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                            ${i18next.t('Sounds')} 
                            <div class="ninchat-embed-dropdown-item-button-switch-wrapper">
                            <div class="ninchat-embed-dropdown-item-button-switch ${soundOn ? 'on' : ''}">
                                <input aria-checked="${soundOn}" role="switch" type="checkbox" ${soundOn ? 'checked' : ''} />
                                <div class="ninchat-embed-dropdown-item-button-switch-svg check-icon ${soundOn ? 'show' : ''}">
                                    ${switchCheckIcon(24)}
                                </div>
                                <div class="ninchat-embed-dropdown-item-button-switch-svg x-icon ${soundOn ? '' : 'show'}">
                                    ${switchXIcon()}
                                </div>
                            </div>
                            </div>
                        </button>
                    </li>`
        } else if (option.name === DropdownOptions.ChatList) {
            return `
                <li class="ninchat-embed-dropdown-item">
                    <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                        <div class='ninchat-embed-dropdown-item-button-icon  ${option.name}'>${chatsIcon()}</div> <span>${i18next.t('Chat list')}</span>
                    </button>
                </li>`
        } else if (option.name === DropdownOptions.Close) {
            return `
                <li class="ninchat-embed-dropdown-item">
                    <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                        <div class='ninchat-embed-dropdown-item-button-icon ${option.name}'>${closeIcon()}</div> <span>${i18next.t('Close chat')}</span>
                    </button>
                </li>`
        } else if (option.name === DropdownOptions.Minimize) {
            return `
                <li class="ninchat-embed-dropdown-item">
                    <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                        <div class='ninchat-embed-dropdown-item-button-icon ${option.name}'>${minimizeIcon()}</div> <span>${i18next.t('Minimize')}</span>
                    </button>
                </li>`
        } else if (option.name === DropdownOptions.Expand) {
            return `
                <li class="ninchat-embed-dropdown-item">
                    <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                        <div class='ninchat-embed-dropdown-item-button-icon ${option.name}'>${isExpanded ? shrinkIcon(`ninchat-embed-dropdown-shrink${Math.random().toString()}`) : resizeIcon()}</div> <span>${isExpanded ? i18next.t('Shrink') : i18next.t('Expand')}</span>
                    </button>
                </li>`
        }
        return `
                <li class="ninchat-embed-dropdown-item">
                    <button class="ninchat-embed-dropdown-item-button ${option.name}" data-name="${option.name}">
                        ${'icon' in option && option.icon ? `
                            <div class="ninchat-embed-dropdown-item-button-icon ${option.name}" >
                                ${option.icon.svg ? option.icon.svg : ''}
                                ${option.icon.src ? `<img alt="${option.icon.alt || ''}" height="${option.icon.height || ''}" src="${option.icon.src}" width="${option.icon.width || ''}" />` : ''}
                            </div>
                        ` : ''}
                        <span>${'label' in option ? option.label || '' : ''}</span>
                    </button>
                </li>`
    }).join('') || ''


    // rendering dropdown options need to be in render as i18next object is not available in template init
    if (dropdownContent) {
        dropdownContent.innerHTML = renderDropdownOptions(options?.headerOptions?.dropdownOptions || [])
    }

    const promoBubble = container.querySelector('.ninchat-embed-promobubble-wrapper')
    state[sessionKey].promoBubbleHidden = promoBubble?.classList.contains('hide-pernament') || promoBubble?.classList.contains('hide')

    if (chatListButton) {
        if (showChatList) {
            chatListButton.classList.remove('hide')
            chatListButton.setAttribute('title', actions?.chatList?.buttonTitle || '')
            chatListButton.setAttribute('aria-label', actions?.chatList?.buttonTitle || '')
            chatListButton.innerHTML = `${renderChatsIcon(actions)} <span class='text'>${actions?.chatList?.text || ''}</span>`
        } else {
            chatListButton.classList.add('hide')
        }
    }

    if (dropdownButton) {
        if (showDropdown) {
            dropdownButton.classList.remove('hide')
            dropdownButton.setAttribute('title', actions?.dropdown?.buttonTitle || '')
            dropdownButton.setAttribute('aria-label', actions?.dropdown?.buttonTitle || '')
            dropdownButton.removeAttribute('aria-hidden')
            dropdownButton.innerHTML = `${renderDropdownIcon(actions)} <span class='text'>${actions?.dropdown?.text || ''}</span>`
        } else {
            dropdownButton.classList.add('hide')
            dropdownButton.setAttribute('aria-hidden', 'true')
        }
    }

    if (minimizeButton) {
        if (showMinimize) {
            minimizeButton.classList.remove('hide')
            minimizeButton.setAttribute('title', actions?.minimize?.buttonTitle || '')
            minimizeButton.setAttribute('aria-label', actions?.minimize?.buttonTitle || '')
            minimizeButton.removeAttribute('aria-hidden')
            minimizeButton.innerHTML = `<span class='text'>${actions?.minimize?.text || ''}</span> ${renderMinimizeIcon(actions)} `
        } else {
            minimizeButton.classList.add('hide')
            minimizeButton.setAttribute('aria-hidden', 'true')
        }
    }

    if (expandButton) {
        if (showExpand) {
            expandButton.classList.remove('hide')
            expandButton.setAttribute('title', actions?.expand?.buttonTitle || '')
            expandButton.setAttribute('aria-label', actions?.expand?.buttonTitle || '')
            expandButton.removeAttribute('aria-hidden')
            expandButton.innerHTML = `<span class='text'>${actions?.expand?.text || ''}</span> ${renderResizeIcon(actions)}`
        } else {
            expandButton.classList.add('hide')
            expandButton.setAttribute('aria-hidden', 'true')
        }
    }

    if (shrinkButton) {
        if (showShrink) {
            shrinkButton.classList.remove('hide')
            shrinkButton.setAttribute('title', actions?.expand?.buttonTitle || '')
            shrinkButton.setAttribute('aria-label', actions?.expand?.buttonTitle || '')
            shrinkButton.removeAttribute('aria-hidden')
            shrinkButton.innerHTML = `<span class='text'>${actions?.expand?.text || ''}</span> ${renderShrinkIcon(actions, `ninchat-embed-shrink${Math.random().toString()}`)}`
        } else {
            shrinkButton.classList.add('hide')
            shrinkButton.setAttribute('aria-hidden', 'true')
        }
    }

    if (closeButton) {
        if (showClose) {
            closeButton.classList.remove('hide')
            closeButton.setAttribute('title', actions?.close?.buttonTitle || '')
            closeButton.setAttribute('aria-label', actions?.close?.buttonTitle || '')
            closeButton.removeAttribute('aria-hidden')
            closeButton.innerHTML = `<span class='text'>${actions?.close?.text || ''}</span> ${renderCloseIcon(actions)}`
        } else {
            closeButton.classList.add('hide')
            closeButton.setAttribute('aria-hidden', 'true')
        }
    }

    renderHeader(config, emit)
}

const embedBallTransition = (ev: Event) => {
    if (ev.target && ev.target instanceof HTMLElement) {
        ev.target.classList.add('hide-transition-end')
    }
}

const embedTransition = (ev: Event) => {
    if (ev.target && ev.target instanceof HTMLElement) {
        ev.target.classList.add('minimize-transition-end')
    }
}


// events triggered by wrappper component
export const attachEvents = (sendMessage: ({event}: Partial<EmbedEvents>) => void,
    // eslint-disable-next-line max-params
    container: HTMLElement, config: NinchatEnvironmentConfig, emit: (event: Partial<EmbedEvents>) => void) => {
    if (!container) {
        return
    }

    const embed = container.querySelector('.ninchat-embed')
    const embedBall = container.querySelector('.ninchat-embed-ball')
    const promoBubble = container.querySelector('.ninchat-embed-promobubble-wrapper')
    const dropdownButton = container.querySelector('.ninchat-embed-dropdown-button')
    const dropdownContent = container.querySelector('.ninchat-embed-dropdown-content')

    const sessionKey = config?.sessionKey || ''

    if (!embed) {
        return
    }

    document.addEventListener('click', (ev) => {
        const dropdown = container.querySelector('.ninchat-embed-dropdown')

        if (dropdown && !dropdown.contains(ev.target as Node) && !dropdownButton?.contains(ev.target as Node)) {
            dropdown.classList.remove('active')
        }
    })

    // clicks inside the iframe don't bubble to the parent document, so detect
    // focus moving into the embed content iframe via the window blur event
    window.addEventListener('blur', () => {
        const {activeElement} = document

        if (activeElement?.tagName === 'IFRAME' && embed.querySelector('.ninchat-embed-content')?.contains(activeElement)) {
            const dropdown = container.querySelector('.ninchat-embed-dropdown')

            if (dropdown) {
                dropdown.classList.remove('active')
            }
        }
    })

    dropdownButton?.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        const dropdown = container.querySelector('.ninchat-embed-dropdown')

        const {offsetLeft: left} = dropdownButton as HTMLElement

        if (dropdown) {
            dropdown.setAttribute('style', `left: ${left - 10}px;`)
        }
        if (dropdown) {
            dropdown.classList.toggle('active')
        }
    })


    // shared so both the header minimize button and the dropdown item can trigger it
    const minimizeEmbed = () => {
        embed.classList.remove('ninchat-embed-full')
        embed.classList.add('ninchat-embed-minimized')
        embed.classList.add('state-changed-by-user')

        if (embedBall) {
            embedBall.classList.remove('hide')
            embedBall.classList.remove('hide-transition-end')
            embedBall.querySelector('.ninchat-embed-ball-button')?.setAttribute('aria-expanded', 'false')
            embedBall.removeEventListener('transitionend', embedBallTransition)
            embed?.addEventListener('transitionend', embedTransition)
        }

        render(config, container, emit)
        if (embedBall) {
            focusFirstElement(embedBall as HTMLElement)
        } else {
            focusFirstElement(embed as HTMLElement)
        }
        sendUIToStorage(sendMessage, sessionKey)
    }

    // shared so both the header expand button and the dropdown item can trigger it
    const expandEmbed = () => {
        const isMinimized = embed?.classList.contains('ninchat-embed-minimized')
        embed.classList.add('ninchat-embed-full')
        embed.classList.remove('ninchat-embed-minimized')
        embed.classList.remove('ninchat-embed-disable-focus-trap')

        promoBubble?.classList.add('hide-pernament')
        if (isMinimized) {
            embed.classList.add('state-changed-by-user')
        }

        render(config, container, emit)
        focusFirstElement(embed as HTMLElement)
        sendUIToStorage(sendMessage, sessionKey)
    }

    // shared so both the header shrink button and the dropdown item can trigger it
    const shrinkEmbed = () => {
        const isMinimized = embed?.classList.contains('ninchat-embed-minimized')

        embed.classList.remove('ninchat-embed-full')
        embed.classList.remove('ninchat-embed-minimized')
        embed.classList.remove('ninchat-embed-disable-focus-trap')
        if (isMinimized) {
            embed.classList.add('state-changed-by-user')
        }
        render(config, container, emit)
        focusFirstElement(embed as HTMLElement)
        sendUIToStorage(sendMessage, sessionKey)
    }

    // dropdown items are re-rendered on every render() call, so bind once to the
    // persistent list and delegate clicks to the button that was actually clicked
    dropdownContent?.addEventListener('click', (ev) => {
        const target = ev.target as HTMLElement
        const button = target.closest('.ninchat-embed-dropdown-item-button')

        if (!button) {
            return
        }

        ev.stopPropagation()

        const name = button.getAttribute('data-name')
        const dropdown = container.querySelector('.ninchat-embed-dropdown')

        if (name === DropdownOptions.Mute) {
            state[sessionKey].mute = !state[sessionKey].mute
            if (state[sessionKey].mute) {
                audioManager.mute()
            } else {
                audioManager.unmute()
            }

            const switchComponent = document.querySelector('.ninchat-embed-dropdown-item-button-switch')
            const switchInput = switchComponent?.querySelector('input')
            const switchCheckIconParent = switchComponent?.querySelector('.ninchat-embed-dropdown-item-button-switch-svg.check-icon')
            const switchXIconParent = switchComponent?.querySelector('.ninchat-embed-dropdown-item-button-switch-svg.x-icon')

            const soundsOn = !state[sessionKey].mute
            if (soundsOn) {
                switchInput?.setAttribute('aria-checked', 'true')
                if (switchInput) {
                    switchInput.checked = true
                }
                switchComponent?.classList.add('on')
                switchCheckIconParent?.classList.add('show')
                switchXIconParent?.classList.remove('show')
            } else {
                switchInput?.setAttribute('aria-checked', 'false')
                if (switchInput) {
                    switchInput.checked = false
                }
                switchComponent?.classList.remove('on')
                switchCheckIconParent?.classList.remove('show')
                switchXIconParent?.classList.add('show')
            }
            sendUIToStorage(sendMessage, sessionKey)
        }

        if (name === DropdownOptions.Close) {
            sendMessage({event: EmbedEvent.EmbedClose})
        }

        if (name === DropdownOptions.ChatList) {
            // TODO: implement chat list action
        }

        if (name === DropdownOptions.Minimize) {
            minimizeEmbed()
        }

        if (name === DropdownOptions.Expand) {
            if (embed.classList.contains('ninchat-embed-full')) {
                shrinkEmbed()
            } else {
                expandEmbed()
            }
        }

        const option = (config?.floatingOptions?.headerOptions?.dropdownOptions || []).find((item) => item.name === name)

        if (option && 'onSelect' in option && typeof option.onSelect === 'function') {
            option.onSelect()
        }

        if (option && 'closeDropdownAfterSelect' in option && option.closeDropdownAfterSelect) {
            dropdown?.classList.remove('active')
        }
    })

    embed.querySelector('.ninchat-embed-close-button')?.addEventListener('click', () => {
        const isMinimized = embed?.classList.contains('ninchat-embed-minimized')

        if (isMinimized) {
            sendMessage({
                clearData: true,
                event: EmbedEvent.EmbedClose,
            })
        } else {
            sendMessage({event: EmbedEvent.EmbedClose})
        }
    })

    // expand
    embed.querySelector('.ninchat-embed-expand-button')?.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        expandEmbed()
    })

    // shrink
    embed.querySelector('.ninchat-embed-shrink-button')?.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        shrinkEmbed()
    })

    // minimized toggle
    embed.querySelector('.ninchat-embed-minimize-button')?.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        minimizeEmbed()
    })

    const titleClickHandler = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (embed.classList.contains('ninchat-embed-minimized')) {
            embed.classList.remove('ninchat-embed-minimized')
            embed.classList.remove('ninchat-embed-disable-focus-trap')
            embed.classList.add('state-changed-by-user')
            promoBubble?.classList.add('hide-pernament')
        } else if (!state[sessionKey].heroFullVisible) {
            sendMessage({event: EmbedEvent.EmbedHero})
            state[sessionKey].heroFullAbsoluteVisible = !state[sessionKey].heroFullAbsoluteVisible
        }

        render(config, container, emit)
        focusFirstElement(embed as HTMLElement)
        sendUIToStorage(sendMessage, sessionKey)
    }

    embed.querySelector('button.ninchat-embed-header-title-button')?.addEventListener('click', titleClickHandler)
    embed.querySelectorAll('.ninchat-embed-promobubble').forEach((pb) => {
        pb.addEventListener('click', titleClickHandler)
    })

    if (embedBall) {
        const clickHandler = (ev: any) => {
            embedBall.addEventListener('transitionend', embedBallTransition)
            embed.removeEventListener('transitionend', embedTransition)

            ev.preventDefault()
            ev.stopPropagation()
            embed.classList.remove('ninchat-embed-minimized')
            embed.classList.remove('ninchat-embed-disable-focus-trap')
            embed.classList.remove('minimize-transition-end')
            embed.classList.add('state-changed-by-user')
            embedBall.querySelector('.ninchat-embed-ball-button')?.setAttribute('aria-expanded', 'true')

            embedBall.classList.add('hide')
            promoBubble?.classList.add('hide-pernament')

            render(config, container, emit)
            focusFirstElement(embed as HTMLElement)

            sendUIToStorage(sendMessage, sessionKey)
        }

        embedBall.querySelector('.ninchat-embed-ball-button')?.addEventListener('click', clickHandler)
        embedBall.querySelectorAll('.ninchat-embed-promobubble').forEach((pb) => {
            pb.addEventListener('click', clickHandler)
        })

        embedBall.querySelector('.ninchat-embed-ball-close-button')?.addEventListener('click', (ev) => {
            ev.preventDefault()
            ev.stopPropagation()

            sendMessage({
                clearData: true,
                event: EmbedEvent.EmbedClose,
            })
        })
    }

    if (promoBubble) {
        promoBubble.querySelector('.ninchat-embed-promobubble-close-button')?.addEventListener('click', () => {
            promoBubble.classList.add('hide-pernament')
            render(config, container, emit)
            sendUIToStorage(sendMessage, sessionKey)
        })
    }


    // let currentIndex = 0
    // let lastAction = ''
    // const getFocusableVisibleElements = () => {
    //     const focusableElements: any = [...embed.querySelectorAll(focusable)]
    //     return focusableElements.filter((el: any) => {
    //         if (el.checkVisibility({
    //             contentVisibilityAuto: true,
    //             // opacityProperty: true,
    //             visibilityProperty: true,
    //         })) {
    //             return true
    //         }
    //         return false
    //     })
    // }

    // const focusDown = () => {
    //     const focusableVisibleElements = getFocusableVisibleElements()


    //     const index = currentIndex + 1
    //     const nextElement = focusableVisibleElements[index]

    //     if (nextElement) {
    //         nextElement.focus()
    //         currentIndex = index
    //     } else {
    //         focusableVisibleElements[0]?.focus()
    //         currentIndex = 0
    //     }
    //     lastAction = 'down'
    // }

    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // const focusUp = () => {
    //     const focusableVisibleElements = getFocusableVisibleElements()

    //     const index = currentIndex - 1
    //     const prevElement = focusableVisibleElements[index]
    //     if (prevElement) {
    //         prevElement.focus()
    //         currentIndex = index
    //     } else {
    //         focusableVisibleElements[focusableVisibleElements.length - 1]?.focus()
    //         currentIndex = focusableVisibleElements.length - 1
    //     }
    //     lastAction = 'up'
    // }

    // window?.addEventListener('keydown', (e: KeyboardEvent) => {
    //     if (!embed.classList.contains('ninchat-embed-minimized')) {
    //         switch (e.key) {
    //             case 'Tab': {
    //                 if (!embed.classList.contains('ninchat-embed-disable-focus-trap') && !embed.classList.contains('ninchat-embed-disable-focus-trap-iframe')) {
    //                     e.preventDefault()

    //                     if (e.shiftKey) {
    //                         focusUp()
    //                     } else {
    //                         focusDown()
    //                     }
    //                 }

    //                 break
    //             }
    //             case 'Escape':
    //                 if (!embed.classList.contains('ninchat-embed-minimized')) {
    //                     embed.classList.add('ninchat-embed-disable-focus-trap')
    //                 }
    //                 break
    //             default:
    //                 break
    //         }
    //     }
    // }, {capture: true})


    // window.addEventListener('focusin', (ev: any) => {
    //     if (!embed.classList.contains('ninchat-embed-minimized')) {
    //         if (ev.target?.classList.contains('after-iframe-button')) {
    //             if (lastAction === 'down') {
    //                 embed.classList.remove('ninchat-embed-disable-focus-trap-iframe')
    //                 focusDown()
    //             } else if (lastAction === 'up') {
    //                 embed.classList.add('ninchat-embed-disable-focus-trap-iframe')
    //             }
    //         } else if (ev.target?.classList.contains('before-iframe-button')) {
    //             if (lastAction === 'down') {
    //                 embed.classList.add('ninchat-embed-disable-focus-trap-iframe')
    //             } else if (lastAction === 'up') {
    //                 embed.classList.remove('ninchat-embed-disable-focus-trap-iframe')
    //                 focusUp()
    //             }
    //         }
    //     }
    // })
}

// handle events from embed iframe
export const handleChildEvents = (
    event: MessageEvent,
    container: HTMLElement,
    config: NinchatEnvironmentConfig,
    sendMessage: (message: Partial<EmbedEvents>) => void,
    isWebView: boolean,
    emit: (event: Partial<EmbedEvents>) => void,
// eslint-disable-next-line max-params
) => {
    const parsedEvent = JSON.parse(event.data)
    const {sessionKey} = parsedEvent

    // eslint-disable-next-line no-console
    // console.log('EMBED - MESSAGE FROM CHILD IFRAME', parsedEvent)

    if (!state[sessionKey]) {
        state[sessionKey] = {}
    }

    state[sessionKey].container = container

    if (parsedEvent.event === EmbedEvent.Route) {
        state[sessionKey].currentRoute = parsedEvent.route
    }

    if (parsedEvent.event === EmbedEvent.EmbedAudienceQueue) {
        // eslint-disable-next-line prefer-destructuring
        state[sessionKey].queuePosition = parsedEvent.queuePosition
    }

    if (parsedEvent.event === EmbedEvent.EmbedTranslations) {
        const {lang} = parsedEvent

        i18next
            .use(initReactI18next)
            .init({
                interpolation: {escapeValue: false},
                keySeparator: '::',
                lng: lang,
                nsSeparator: ':::',
                resources: {[lang]: {translation: parsedEvent.translations}},
                returnEmptyString: false,
                supportedLngs: ['en', 'fi', 'sv'],
            })
            .then(() => {
                render(config, container, emit)
            })
    }

    if (parsedEvent.event === EmbedEvent.EmbedMembers) {
        state[sessionKey].members = parsedEvent.members || []
        state[sessionKey].channelAttrs = parsedEvent.channel_attrs || {}
    }

    if (parsedEvent.event === EmbedEvent.EmbedClose && container) {
        const {clearData} = parsedEvent

        if (clearData || !config?.floating) {
            // remove embed completely
            container.remove()
        } else {
            // go to minimized state
            const embed = container.querySelector('.ninchat-embed')
            const embedBall = container.querySelector('.ninchat-embed-ball')

            if (embed) {
                embed.classList.remove('ninchat-embed-full')
                embed.classList.add('ninchat-embed-minimized')
                embed.classList.add('state-changed-by-user')
            }

            if (embedBall) {
                embedBall.classList.remove('hide')
                embedBall.classList.remove('hide-transition-end')
                embedBall.removeEventListener('transitionend', embedBallTransition)
                if (embed) {
                    embed.addEventListener('transitionend', embedTransition)
                }
            }

            render(config, container, emit)
            // sendUIToStorage(container, sendMessage)

            focusFirstElement(embed as HTMLElement)
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedCloseCancelled) {
        const embedClose = container.querySelector('.ninchat-embed-close-button') as HTMLButtonElement
        embedClose?.focus()
    }

    if (parsedEvent.event === EmbedEvent.EmbedVideo) {
        state[sessionKey].isVideoActive = parsedEvent.active
        state[sessionKey].isVideoChannel = parsedEvent.isVideoChannel
    }

    if (parsedEvent.event === EmbedEvent.ActivityCount) {
        state[sessionKey].highlights = parsedEvent.highlights
    }

    if (parsedEvent.event === EmbedEvent.EmbedHero) {
        state[sessionKey].heroFullVisible = parsedEvent.heroFullVisible
    }

    if (parsedEvent.event === EmbedEvent.EmbedChannelStatus) {
        const embed = container.querySelector('.ninchat-embed')
        const isMinimized = embed?.classList.contains('ninchat-embed-minimized')

        if (parsedEvent.channel_status && isMinimized) {
            state[sessionKey].channelStatus = parsedEvent.channel_status
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedUI) {
        loadUIFromStorage(sessionKey, parsedEvent.ui, config)
    }

    if (parsedEvent.event === EmbedEvent.EmbedEscape) {
        const embed = container.querySelector('.ninchat-embed')
        if (embed) {
            embed.classList.add('ninchat-embed-disable-focus-trap')
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedSSO) {
        const {url} = parsedEvent
        if (url) {
            window.location.href = url
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedDownload) {
        const {
            url, fileAttrs,
        } = parsedEvent
        // only handle it if it's not webview, in webview we are handling it differently
        if (url && !isWebView) {
            downloadFile(url, fileAttrs?.name)
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedSound) {
        const {
            sound, mute,
        } = parsedEvent

        if (mute === true) {
            state[sessionKey].mute = true
            audioManager.mute()
            sendUIToStorage(sendMessage, sessionKey)
        } else if (mute === false) {
            state[sessionKey].mute = false
            audioManager.unmute()
            sendUIToStorage(sendMessage, sessionKey)
        }

        if (sound) {
            if (state[sessionKey].state === 'minimized') {
                audioManager?.playSound(`${sound}Minimized` as AudioEvents)
            } else {
                audioManager?.playSound(sound)
            }
        }
    }

    if (parsedEvent.event === EmbedEvent.EmbedDropdownAction) {
        const {name} = parsedEvent
        const dropdownOptions = [
            // eslint-disable-next-line no-extra-parens
            ...(config?.containerOptions?.headerOptions?.dropdownOptions || []),
            // eslint-disable-next-line no-extra-parens
            ...(config?.floatingOptions?.headerOptions?.dropdownOptions || []),
        ]
        const option = dropdownOptions.find((item) => item.name === name)

        if (option && 'onSelect' in option && typeof option.onSelect === 'function') {
            option.onSelect()
        }
    }

    render(config, container, emit)
}
